import cn from 'classnames';
import styles from './Divider.module.css';

type Props = {
  className?: string;
  children?: React.ReactNode;
};

export function Divider({ className, children }: Props) {
  return <div className={cn(styles.Divider, className)}>{children}</div>;
}
